import React, { useEffect, useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Button } from '@mui/material';

import { useNavigate } from 'react-router-dom';

import Switch from '@mui/material/Switch';

import api from '../../API/api';

import GeneralAction from '../panel/generalAction';



export default function ViewResume(props) {

    const navigation = useNavigate()



    const [hiring, setHiring] = useState();

    useEffect(() => {
        getResumes()
    }, [])



    const getResumes = () => {
        api.getResumes().then((res) => {
            setHiring(res.data.hiring)
            // console.log(res, 'asudhi');
        })
            .catch((err) => {
                // console.log(err.response);
            })
    }

    // const [status, setStatus] = useState(true);
    // const changeRecruiterStatus = (id, status) => {
    //     console.log(id, status);
    //     api.changeRecruiterStatus(id, status).then((res) => {
    //         console.log(res);
    //         getResumes();
    //     })
    //         .catch((err) => {
    //             console.log(err.response);
    //         })

    // }




    return (
        <div className='py-3'>
            {/* <div className="row">
                <div className='py-3'>
                    <Button variant='contained' color='error' fullWidth>{props.school && props.school.schoolName}</Button>
                </div>
            </div> */}

            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                    <TableHead sx={{ backgroundColor: 'black' }}>
                        <TableRow>
                            <TableCell sx={{ color: 'white', fontWeight: '800', padding: '15px' }}>Post
                            </TableCell>
                            <TableCell sx={{ color: 'white', fontWeight: '800', padding: '15px' }}>Name</TableCell>
                            <TableCell sx={{ color: 'white', fontWeight: '800', padding: '15px' }}>Number</TableCell>
                            <TableCell sx={{ color: 'white', fontWeight: '800', padding: '15px' }}>Email</TableCell>
                            <TableCell sx={{ color: 'white', fontWeight: '800', padding: '15px' }} >Resume</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {hiring && hiring.map((row) => (
                            <TableRow
                                key={row.id}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell sx={{ p: 2 }}> {row.post
                                } </TableCell>
                                <TableCell sx={{ p: 2 }}> {row.name} </TableCell>
                                <TableCell > {row.number} </TableCell>
                                <TableCell > {row.email} </TableCell>
                                <TableCell >
                                    <a href={`${process.env.REACT_APP_BACKEND}assets/resume/${row.resume}`} target='_blank'>
                                        View Resume
                                    </a>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

        </div>
    );
}